module.exports = __webpack_public_path__ + "fonts/analogue-italic-webfont.8b838af.woff2";